{
    "name": "client",
    "version": "0.0.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve -c dev-edge",
        "local-cloud": "ng serve -c local-cloud --proxy-config proxy.conf.json",
        "local-cypress": "ng serve -c local-cloud --proxy-config proxy.conf.json --host 0.0.0.0",
        "local-edge": "ng serve -c local-edge --proxy-config proxy.conf.json",
        "dev-cloud": "ng serve -c dev-cloud",
        "dev-edge": "ng serve -c dev-edge",
        "prod-cloud": "ng serve -c prod-cloud",
        "prod-edge": "ng serve -c prod-edge",
        "demo": "ng serve -c demo",
        "client": "ng serve -c client",
        "build": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration production -c dev-edge",
        "build-cloud": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration production -c dev-cloud",
        "test": "jest --silent --coverage --coverageReporters=json-summary  --maxWorkers=50%",
        "test:ci": "jest --silent --reporters=jest-junit --reporters=default --coverage",
        "lint": "ng lint",
        "eslint": "eslint src/**/*.ts",
        "e2e": "ng e2e",
        "coverage": "jest --coverage",
        "build-electron": "ng build -c electron --base-href ./ --output-path ./../electron/application/client",
        "prettier": "prettier --write 'src/**/*.ts'"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "19.2.0",
        "@angular/cdk": "19.2.1",
        "@angular/common": "19.2.0",
        "@angular/compiler": "^19.2.0",
        "@angular/core": "19.2.0",
        "@angular/forms": "19.2.0",
        "@angular/localize": "19.2.0",
        "@angular/material": "19.2.1",
        "@angular/platform-browser": "19.2.0",
        "@angular/platform-browser-dynamic": "19.2.0",
        "@angular/router": "19.2.0",
        "@foblex/2d": "^1.2.2",
        "@foblex/flow": "^19.0.0",
        "@foblex/mediator": "^1.1.3",
        "@foblex/platform": "^1.0.4",
        "@foblex/utils": "^1.1.1",
        "@ngrx/signals": "^19.2.1",
        "@ngx-translate/core": "^14.0.0",
        "@ngx-translate/http-loader": "^7.0.0",
        "bcryptjs": "^2.4.3",
        "blob-util": "^2.0.2",
        "dayjs": "^1.11.10",
        "diff": "^5.2.0",
        "dompurify": "^3.0.6",
        "echarts": "^6.1.0",
        "file-saver": "^2.0.5",
        "fit-curve": "^0.2.0",
        "fullscreen-polyfill": "^1.0.4",
        "html-to-image": "^1.11.11",
        "jest-junit": "^16.0.0",
        "jspdf": "^4.2.1",
        "jspreadsheet": "^11.4.10",
        "jspreadsheet-ce": "^4.2.1",
        "lodash": "^4.17.21",
        "ngx-color": "^7.3.3",
        "ngx-color-picker": "^14.0.0",
        "ngx-toastr": "^16.2.0",
        "paper": "^0.12.17",
        "pdfjs-dist": "^6.3.289",
        "pdfmake": "^0.2.10",
        "print-js": "^1.6.0",
        "rxjs": "^7.8.0",
        "socket.io-client": "^4.8.1",
        "tslib": "^2.8.1",
        "xlsx": "^0.18.5",
        "yup": "^1.4.0",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular/build": "^19.2.0",
        "@angular/cli": "19.2.0",
        "@angular/compiler-cli": "19.2.0",
        "@types/dompurify": "^3.0.5",
        "@types/file-saver": "^2.0.7",
        "@types/jest": "^29.5.12",
        "@types/lodash": "^4.14.202",
        "@typescript-eslint/eslint-plugin": "^7.3.1",
        "@typescript-eslint/parser": "^7.3.1",
        "eslint": "^8.57.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-prettier": "^5.1.3",
        "jest": "^29.7.0",
        "jest-preset-angular": "^14.0.3",
        "ng-mocks": "^14.12.1",
        "prettier": "^3.2.5",
        "source-map-explorer": "^2.5.3",
        "ts-jest": "^29.1.2",
        "typescript": "~5.8.2"
    }
}
